import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import defaultFormValues from "../../VenueSearch/defaultFormValues";
import submitFn from "../../VenueSearch/submitFn";
import getValidationSchema from "../../VenueSearch/validationSchema";
import InitialEventDetailsStage from "../../VenueSearch/components/stages/InitialEventDetailsStage";
import GuestsAndLayoutStage from "../../VenueSearch/components/stages/GuestsAndLayoutStage";
import StylesAndCateringStage from "../../VenueSearch/components/stages/StylesAndCateringStage";
import BudgetAndCorpOrPrivateStage from "../../VenueSearch/components/stages/BudgetAndCorpOrPrivateStage";
import classes from "./styles.module.scss";
import mainClasses from "../../VenueSearch/styles/styles.module.scss";
import "./styleOverrides.scss";
import StageId from "../../VenueSearch/components/StageContainer/StageId";
import UserDetailsStage from "../../VenueSearch/components/stages/UserDetailsStage";
import { ConfigContext } from "../../VenueSearch/context";
import { Flavour } from "../../VenueSearch/constants";

const nonSrpRedirectFlavours = [Flavour.CONCIERGE, Flavour.WHITE_LABEL];

const getVerticalStages = ({ isLoggedIn, eventType, flavour }) =>
  [
    StageId.InitialEventDetails,
    StageId.GuestsAndLayout,
    StageId.StylesAndCatering,
    StageId.BudgetAndCorpOrPrivate,
    !isLoggedIn &&
      (eventType?.isCorporate || nonSrpRedirectFlavours.includes(flavour)) &&
      StageId.UserDetails,
  ].filter(Boolean);

const VerticalFormContent = ({
  setStages,
  isLoggedIn,
  loading,
  verticalStages,
  isValid,
  handleSubmit,
  flavour,
  values: { eventType },
}) => {
  useEffect(() => {
    setStages(getVerticalStages({ eventType, isLoggedIn, flavour }));
  }, [setStages, eventType, isLoggedIn, flavour]);
  return (
    <Form className={mainClasses.InlineForm}>
      <InitialEventDetailsStage />
      <GuestsAndLayoutStage />
      <StylesAndCateringStage />
      <BudgetAndCorpOrPrivateStage />
      {verticalStages.includes(StageId.UserDetails) && <UserDetailsStage />}
      <div className={mainClasses.ButtonWrapper}>
        <vs-btn
          className="venueSearch-button"
          type="primary"
          label="Find me a Venue"
          disabled={!isValid || loading}
          loading={loading}
          onClick={handleSubmit}
        />
      </div>
    </Form>
  );
};

VerticalFormContent.propTypes = {
  setStages: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  verticalStages: PropTypes.arrayOf(PropTypes.string).isRequired,
  isValid: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  flavour: PropTypes.oneOf(Object.values(Flavour)).isRequired,
  values: PropTypes.object.isRequired,
};

const VerticalForm = ({ onCompletion, conciergeCard }) => {
  const { base, flavour, user, phone } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const isLoggedIn = !!user && !!phone;
  const [verticalStages, setStages] = useState(
    getVerticalStages({ isLoggedIn })
  );

  return (
    <div className={classes.form}>
      <Formik
        initialValues={defaultFormValues({ user: user, userPhone: phone })}
        onSubmit={submitFn({
          useStages: false,
          base,
          setLoading,
          onCompletion,
          flavour,
          conciergeCard,
        })}
        validationSchema={getValidationSchema(verticalStages)}
      >
        {(formik) => (
          <VerticalFormContent
            {...{
              setStages,
              verticalStages,
              isLoggedIn,
              loading,
              flavour,
              ...formik,
            }}
          />
        )}
      </Formik>
    </div>
  );
};

VerticalForm.propTypes = {
  onCompletion: PropTypes.func,
};

export default VerticalForm;
